<script>
	import SmartLink from '../helpers/SmartLink.svelte';
	import { useCustomCss, pages } from "../share/stores";

	export let extraClass = "close right";
	export let text = "SCHLIESSEN";
</script>

<div class:customCss={$useCustomCss}>
	<SmartLink
			url={$pages[$pages.length - 2]?.path || $pages[$pages.length - 1].path}
			{extraClass}
			{text}
			callBack={() => {}}
	/>
</div>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	div {
		position: sticky;
		top: 0;
		left: 100%;
		margin-right: var(--spacing-mobile);
		width: fit-content;
		text-transform: uppercase;
		z-index: 10;

		:global(.close.right), :global(.close.left) {
			// same as h1 in global.scss
			line-height: 5.5rem;

			@include for-desktop-up {
				line-height: 8rem;
			}
		}

		:global(.close.right > a), :global(.close.left > a),
		:global(.close.right > button a), :global(.close.left > button a) {
			@include for-desktop-up {
				font-size: 2.5rem;
				line-height: 4rem;
				font-weight: 300;
			}
		}

		:global(.close.right > a), :global(.close.right > button a) {
			color: $color-burgeins-6;
		}

		:global(.close.left > a), :global(.close.left > button a) {
			color: white;
		}

		:global(.close.right > a::before), :global(.close.right > button a::before) {
			background-color: $color-burgeins-6;
		}

		:global(.close.left > a::after), :global(.close.left > button a::after) {
			background-color: white;
		}

		:global(.close.right.red > a),
		:global(.close.right.red > button a) {
			color: red;
		}

		:global(.close.right.red > a::before),
		:global(.close.right.red > button a::before) {
			background-color: red;
		}
	}

	:global(.useCustomCss .container .left) {
		.close.right > a, .close.right > button a {
			color: white !important;
		}

		.close.right > a::before, .close.left > a::before,
		.close.right > button a::before, .close.left > button a::after {
			background-color: white !important;
		}
	}
	:global(.container .left .outer .inner .close a), :global(.container .left .outer .inner .close button a) {
		color: white;
	}
	:global(.container .left .outer .inner .close a::before) {
		background-color: white;
	}
</style>
